define(function(require) {

    return {
        FIRST: {
            "ThemeSet3" : {
                visibleLayers: ["Unite_2008_1", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet5" : {
                visibleLayers: ["Unite_2008_1", "Ecole_CSF_Prim_18", "Ecolesprimairesfrancophones20172018_2", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet6" : {
                visibleLayers: ["Unite_2008_1", "Ecole_CSF_Sec_18", "Ecolessecondairesfrancophones20172018_2", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet9" : {
                visibleLayers: ["Unite_2008_1", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet10" : {
                visibleLayers: ["Unite_2008_1", "Ecole_CSF_Prim_18", "Ecolesprimairesfrancophones20172018_2", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet11" : {
                visibleLayers: ["Unite_2008_1", "Ecole_CSF_Sec_18", "Ecolessecondairesfrancophones20172018_2", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet15" : {
                visibleLayers: ["Unite_2008_1", "Cs_Anglo_2", "Cs_Statut_2"]
            },
            "ThemeSet16" : {
                visibleLayers: ["Unite_2008_1", "Ecole_CSA_Prim_18", "Ecolesprimairesanglophones20172018_2", "Cs_Anglo_2", "Cs_Statut_2"]
            },
            "ThemeSet17" : {
                visibleLayers: ["Unite_2008_1", "Ecole_CSA_Sec_18", "Ecolessecondairesanglophones20172018_2", "Cs_Anglo_2", "Cs_Statut_2"]
            },
            "ThemeSet20" : {
                visibleLayers: ["Unite_2008_1", "Cs_Anglo_2", "Cs_Statut_2"]
            },
            "ThemeSet21" : {
                visibleLayers: ["Unite_2008_1", "Ecole_CSA_Prim_18", "Ecolesprimairesanglophones20172018_2", "Cs_Anglo_2", "Cs_Statut_2"]
            },
            "ThemeSet22" : {
                visibleLayers: ["Unite_2008_1", "Ecole_CSA_Sec_18", "Ecolessecondairesanglophones20172018_2", "Cs_Anglo_2", "Cs_Statut_2"]
            }
        },
        LATER: {
            "ThemeSet3" : {
                visibleLayers: ["Unite_2018", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet5" : {
                visibleLayers: ["Unite_2018", "Ecole_CSF_Prim_18", "Ecolesprimairesfrancophones20172018_2", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet6" : {
                visibleLayers: ["Unite_2018", "Ecole_CSF_Sec_18", "Ecolessecondairesfrancophones20172018_2", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet9" : {
                visibleLayers: ["Unite_2018", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet10" : {
                visibleLayers: ["Unite_2018", "Ecole_CSF_Prim_18", "Ecolesprimairesfrancophones20172018_2", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet11" : {
                visibleLayers: ["Unite_2018", "Ecole_CSF_Sec_18", "Ecolessecondairesfrancophones20172018_2", "Cs_Franco_2", "Cs_Statut_2"]
            },
            "ThemeSet15" : {
                visibleLayers: ["Unite_2018", "Cs_Anglo_2", "Cs_Statut_2"]
            },
            "ThemeSet16" : {
                visibleLayers: ["Unite_2018", "Ecole_CSA_Prim_18", "Ecolesprimairesanglophones20172018_2", "Cs_Anglo_2", "Cs_Statut_2"]
            },
            "ThemeSet17" : {
                visibleLayers: ["Unite_2018", "Ecole_CSA_Sec_18", "Ecolessecondairesanglophones20172018_2", "Cs_Anglo_2", "Cs_Statut_2"]
            },
            "ThemeSet20" : {
                visibleLayers: ["Unite_2018", "Cs_Anglo_2", "Cs_Statut_2"]
            },
            "ThemeSet21" : {
                visibleLayers: ["Unite_2018", "Ecole_CSA_Prim_18", "Ecolesprimairesanglophones20172018_2", "Cs_Anglo_2", "Cs_Statut_2"]
            },
            "ThemeSet22" : {
                visibleLayers: ["Unite_2018", "Ecole_CSA_Sec_18", "Ecolessecondairesanglophones20172018_2", "Cs_Anglo_2", "Cs_Statut_2"]
            }
        }
    };
});
